import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "area-chart" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1>Area Chart</h1><p> To create an area chart in <b>vue3-charts</b> you can use the <code>Area</code> layer. You can add the <code>Area</code> layer multiple times or combine it with other layers (<code>Line</code>, <code>Bar</code>, <code>Marker</code>). </p><p> If you have multiple <code>Area</code> layers you can render them as stacked. </p><p> Let&#39;s see a simple example using an <code>Area</code> layer and a <code>Line</code> layer. </p>", 4)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("As you can see the area "),
  /*#__PURE__*/_createElementVNode("code", null, "fill"),
  /*#__PURE__*/_createTextVNode(" color can be a gradient.")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-6" }, "Stacked Area Chart", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" If you have multiple "),
  /*#__PURE__*/_createElementVNode("code", null, "Area"),
  /*#__PURE__*/_createTextVNode(" layers you can render them as stacked using "),
  /*#__PURE__*/_createElementVNode("code", null, "Group"),
  /*#__PURE__*/_createTextVNode(" component. ")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-6" }, "Area Props", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "The area layer allows a number of properties to be specified.", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, "Use areaStyle to set svg styling for each bar.", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold" }, "Ex:", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("ul", { class: "list-disc list-inside" }, [
  /*#__PURE__*/_createElementVNode("li", null, "fill (ex. red)"),
  /*#__PURE__*/_createElementVNode("li", null, "fill-opacity"),
  /*#__PURE__*/_createElementVNode("li", null, "etc...")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", null, "What data the bar to render.", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("Ex: "),
  /*#__PURE__*/_createElementVNode("code", null, "['name', 'pl']")
], -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Set how to draw the line. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AreaChart = _resolveComponent("AreaChart")!
  const _component_ChartBlock = _resolveComponent("ChartBlock")!
  const _component_CodeBlock = _resolveComponent("CodeBlock")!
  const _component_StackedAreaChart = _resolveComponent("StackedAreaChart")!
  const _component_Prop = _resolveComponent("Prop")!
  const _component_PropsBlock = _resolveComponent("PropsBlock")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_ChartBlock, {
      chartCode: _ctx.code.chartCode,
      dataCode: _ctx.code.dataCode
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AreaChart)
      ]),
      _: 1
    }, 8, ["chartCode", "dataCode"]),
    _hoisted_6,
    _createVNode(_component_CodeBlock, {
      code: _ctx.code.gradient
    }, null, 8, ["code"]),
    _hoisted_7,
    _hoisted_8,
    _createVNode(_component_ChartBlock, {
      chartCode: _ctx.code.chartCode,
      dataCode: _ctx.code.dataCode
    }, {
      default: _withCtx(() => [
        _createVNode(_component_StackedAreaChart)
      ]),
      _: 1
    }, 8, ["chartCode", "dataCode"]),
    _hoisted_9,
    _hoisted_10,
    _createVNode(_component_PropsBlock, { class: "mt-4" }, {
      default: _withCtx(() => [
        _createVNode(_component_Prop, {
          name: "areaStyle",
          types: ['Object']
        }, {
          default: _withCtx(() => [
            _hoisted_11,
            _hoisted_12,
            _hoisted_13
          ]),
          _: 1
        }),
        _createVNode(_component_Prop, {
          name: "dataKeys",
          types: ['Array'],
          odd: ""
        }, {
          default: _withCtx(() => [
            _hoisted_14,
            _hoisted_15
          ]),
          _: 1
        }),
        _createVNode(_component_Prop, {
          name: "type",
          types: ['normal', 'step', 'natural', 'monotone']
        }, {
          default: _withCtx(() => [
            _hoisted_16
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}